import {BRANDS} from 'const'

export const getMarketingFieldByBrand = (brand, data = {}) => {
  const defaultMarketingField = 'marketing'
  const brandMarketingFields = {
    [BRANDS.twentymin]: 'marketing_20min',
    [BRANDS.lematin]: 'marketing_lematin',
    [BRANDS.lessentiel]: 'marketingLessentiel',
    [BRANDS.autodesjahres]: 'marketingAutodesjahres',
    [BRANDS.cash]: 'marketingCash',
  }

  const marketingFieldName = brandMarketingFields[brand] || defaultMarketingField

  return {
    name: marketingFieldName,
    value: data[marketingFieldName],
  }
}

export const getPhoneNumberFieldByBrand = brand =>
  ({
    [BRANDS.blick]: 'phoneNumber_blick',
  }[brand])

export const getMobileNumberFieldsByBrand = (brand, requiresMigration, userData, data) => {
  const mobileNumberFieldsByBrand = {
    [BRANDS.energy]: 'mobileNumber',
    [BRANDS.moonandstars]: 'mobileNumber_moonandstars',
    [BRANDS.vintage]: 'mobileNumber_vintage',
    [BRANDS.schlager]: 'mobileNumber_schlager',
    [BRANDS.rockit]: 'mobileNumber_rockit',
    [BRANDS.twentymin]: 'mobileNumber_20min',
    [BRANDS.schweizerillustrierte]: 'schweizerillustrierteMobileNumber',
    [BRANDS.cash]: 'mobileNumberCash',
    [BRANDS.wirtschaftsmedien]: 'mobileNumberWime',
    [BRANDS.beobachter]: 'mobileNumberBeo',
    [BRANDS.lessentiel]: 'mobileNumber_lessentiel',
  }

  return mobileNumberFieldsByBrand[brand]
    ? {
        field: mobileNumberFieldsByBrand[brand],
        migrated:
          brand === BRANDS.energy ? requiresMigration && userData.mobileNumber.value === data.mobileNumber : false,
      }
    : {}
}
